import React from "react";
import { Badge } from "./ui/badge";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { faqs } from "../data/mock";

const FAQ = () => {
  return (
    <section id="faq" className="py-20 md:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4">
        <div className="text-center mb-10">
          <Badge className="bg-green-50 text-green-700 border border-green-200 hover:bg-green-50 mb-4">FAQ</Badge>
          <h2 className="text-3xl md:text-5xl font-black text-slate-900 tracking-tight">Smog check questions, answered</h2>
          <p className="text-slate-600 mt-4 text-lg">Common questions from Marin County drivers about STAR-certified smog inspections in Novato.</p>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border border-slate-200 rounded-xl px-5 bg-white data-[state=open]:border-green-300 data-[state=open]:shadow-sm">
              <AccordionTrigger className="text-left font-bold text-slate-900 hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
